import React from 'react';
import { components } from 'react-select';
import Checkbox from '~components/checkbox';

function Option(props) {
  if (props.isMulti) {
    return (
      <components.Option {...props}>
        {props.isMulti && (
          <Checkbox
            disabled={props.isDisabled}
            checked={props.isSelected}
            style={{ marginRight: 8 }}
          />
        )}
        <div style={{ display: 'inline-block' }}>{props.children}</div>
      </components.Option>
    );
  }

  return <components.Option {...props} />;
}

export default Option;
